import 'hammerjs';

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import * as Sentry from '@sentry/angular-ivy';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { initGoogleAnalytics, initGTM } from './initiator';
import { migration } from './migration';

if (environment.production) {
  Sentry.init({
    dsn: 'https://a0e733b347fa7f85b4be52fcfa48aeb7@o4505625092292608.ingest.sentry.io/4505625093931008',
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', environment.siteURL],
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    ignoreErrors: [
      // View Transition API 原生中斷 (瀏覽器自動行為，非 Bug)
      'View transition was skipped',
      'Skipping view transition',
      'Transition was aborted',
      'Transition was skipped',
      'Old view transition aborted',
      'Skipped ViewTransition due to document being hidden',
      'View transition was skipped because document visibility state is hidden.',
      // Android/iOS WebView 殼層物件銷毀錯誤 (App Native 問題)
      'Java object is gone',
      'webkit.messageHandlers',
      // 外部 LinkCollector 等爬蟲腳本之 DOM 尋找失敗
      "Failed to execute 'querySelector' on 'Document'",
      // 本地瀏覽器儲存區 SecurityError / IndexedDB 與 Firebase 網路超時限制
      "Failed to read the 'localStorage' property",
      'Connection to Indexed Database server lost',
      'Attempt to delete range from database',
      'Firebase Storage: Max retry time for operation exceeded',
      'QuotaExceededError',
      // 瀏覽器 Extension 與 Tab 斷線 (非 App 控制)
      'runtime.sendMessage',
      // HTTP 與 GraphQL 網路連線中斷 / 逾時 / 伺服器 504 錯誤 (網路環境問題)
      'Http failure response',
      'ApolloError',
      // Angular Defer 延遲載入區塊與組件銷毀例外
      'NG0750',
      'NG0911',
      'NG0953',
      'Maximum call stack size exceeded',
      'Importing a module script failed',
      // CDN / 資源載入失敗 (例如 404 回傳 html)
      'is not a valid JavaScript MIME type',
      // 業務邏輯阻擋刪除提示 (外鍵約束)
      'has related data'
    ]
  });

  enableProdMode();

  if (!environment.preview) {
    console.log('init google tag manager and google analytics');
    initGTM();
    initGoogleAnalytics();
  }

  migration();
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);

// back scroll position when refresh strategy
// document.addEventListener('DOMContentLoaded', function (event) {
//   var scrollpos = sessionStorage.getItem('scrollpos');
//   console.log('🐞 ~ scrollpos:', scrollpos);
//   if (scrollpos) {
//     setTimeout(() => {
//       console.log('🐞 ~ scrollpos:', scrollpos);
//       window.scrollTo(0, scrollpos);
//       sessionStorage.removeItem('scrollpos');
//     }, 1000);
//   }
// });

// window.addEventListener('beforeunload', function (e) {
//   sessionStorage.setItem('scrollpos', window.scrollY);
// });
